import '@babel/polyfill'
import Vue from 'vue'

import '@/plugins/vuesax'

import App from '@/landing/App.vue'
import router from '@/landing/router'
import store from '@/landing/store'

import '@/firebase'

import { extend, ValidationObserver, ValidationProvider } from 'vee-validate/dist/vee-validate.full'
import 'web-animations-js'

import '@/assets/styles/main.scss'

extend('one_special_char', {
  message: 'The password must contain at least: one uppercase letter, one lowercase letter, one number, and one special character',
  validate: value => {
    const strongRegex = new RegExp('^(?=.*[!@#$%^&*])')
    return strongRegex.test(value)
  }
})

extend('one_upper_case', {
  message: 'The password must contain at least: one uppercase letter, one lowercase letter, one number, and one special character',
  validate: value => {
    const strongRegex = new RegExp('^(?=.*[A-Z])')
    return strongRegex.test(value)
  }
})

extend('one_lower_case', {
  message: 'The password must contain at least: one uppercase letter, one lowercase letter, one number, and one special character',
  validate: value => {
    const strongRegex = new RegExp('^(?=.*[a-z])')
    return strongRegex.test(value)
  }
})

extend('one_number', {
  message: 'The password must contain at least: one uppercase letter, one lowercase letter, one number, and one special character',
  validate: value => {
    const strongRegex = new RegExp('^(?=.*[0-9])')
    return strongRegex.test(value)
  }
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
